import axios from '@/server/axios'

//入园申请表单
export function applyPark(name,company,mail,contact,enterpriseProfile,businessPlan,code) {
  return axios({
    url: 'officialWebsite/ApplicationForAdmission.do',
    method: 'post',
    data: {
      name,
      company,
      mail,
      contact,
      enterpriseProfile,
      businessPlan,
      code
    }
  })
}

//验证码
export function queryQrCode(email) {
  return axios({
    url: 'officialWebsite/sendCode.do',
    method: 'get',
    params: {
      email
    }
  })
}

